/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import logo from "assets/images/profile_icon.png";

import { useSelector } from "react-redux";
import { StoreType } from "../types/genericTypes";

import ModalComponent from "components/Modal";
import {
  Backdrop,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { FormikProvider } from "formik";
import { MuiFileInput } from "mui-file-input";
import { IconUserEdit, IconUsersPlus } from "@tabler/icons-react";
import { useEmpresas } from "hooks/useEmpresas";
import EmpresasModulo from "components/VistaModulos/EmpresasModulo";
import DetallesEmpresa from "components/VistaModulos/DetallesEmpresa";

function Empresas(): JSX.Element {
  const userName = useSelector((state: StoreType) => state?.app?.user?.data?.usuario || null);
  const fotoUser: any = useSelector((state: StoreType) => state?.app?.user?.data?.foto || logo);

  const {
    intl,
    formik,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    empresas,
    //crear proveedor
    isAlertOpenCrearEmpresa,
    handleisAlertOpenCrearEmpresa,
    handleisAlertCloseCrearEmpresa,
    getFieldColor,
    procesandoEmpresa,
    createEditEmpresa,
    idUsuario,
    verDetalleEmpresa,
    setVerDetalleEmpresa,
    isAlertOpenDetalleEmpresa,
    handleisAlertOpenDetalleEmpresa,
    handleisAlertCloseDetalleEmpresa,
    verEditarEmpresa,
    setVerEditarEmpresa,
    desactivarEmpresa,
    activarEmpresa,
    //imagen referencia
    handleChangeLogo,
  } = useEmpresas();

  return (
    <DashboardLayout>
      <MDBox py={2}>
        <Card>
          <CardContent>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ height: "100%", mt: 1 }}
            >
              <Grid xs={12}>
                <Typography variant="h4" sx={{ textAlign: "center" }}>
                  Empresas
                </Typography>
              </Grid>
              <Grid xs={12}>
                <EmpresasModulo
                  verEmpresas={empresas}
                  procesando={procesando}
                  handleisAlertOpenDetalleEmpresa={handleisAlertOpenDetalleEmpresa}
                  setVerDetalleEmpresa={setVerDetalleEmpresa}
                  handleisAlertOpenCrearEmpresa={handleisAlertOpenCrearEmpresa}
                  setVerEditarEmpresa={setVerEditarEmpresa}
                  desactivarEmpresa={desactivarEmpresa}
                  activarEmpresa={activarEmpresa}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </MDBox>

      {/* MODAL PARA VER DETALLES DE LA EMPRESA */}
      <ModalComponent
        esFullScreen
        handleClose={handleisAlertCloseDetalleEmpresa}
        isOpen={isAlertOpenDetalleEmpresa}
        key={"alerta-detalles-empresa"}
        {...(verDetalleEmpresa?.estatus === 1
          ? {
              actions: [
                {
                  title: "Editar empresa",
                  icon: <IconUserEdit stroke={2} />,
                  color: "#D4AF37",
                  hoverColor: "#a98c2c",
                  textColor: "#3D3E3D",
                  handleAction: () => {
                    setVerEditarEmpresa(verDetalleEmpresa);
                    handleisAlertOpenCrearEmpresa();
                  },
                },
              ],
            }
          : {})}
      >
        {verDetalleEmpresa && (
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <br />
              <br />
              <DetallesEmpresa
                verEmpresa={verDetalleEmpresa}
                procesandoEmpresa={procesandoEmpresa}
                idUsuario={idUsuario}
                handleisAlertOpenCrearEmpresa={handleisAlertOpenCrearEmpresa}
                setVerEditarEmpresa={setVerEditarEmpresa}
              />
            </Grid>
          </Grid>
        )}
      </ModalComponent>
      {/* MODAL PARA AÑADIR EMPRESA */}
      <ModalComponent
        handleClose={handleisAlertCloseCrearEmpresa}
        isOpen={isAlertOpenCrearEmpresa}
        key={"alerta-crear-Inventario"}
        titleButtonAction={verEditarEmpresa ? "Editar" : "Añadir"}
        iconButtonAction={
          verEditarEmpresa ? <IconUserEdit stroke={2} /> : <IconUsersPlus stroke={2} />
        }
        disabledButtonAction={!verEditarEmpresa && !formik.isValid}
        handleAction={() => {
          const datos = {
            ...(verEditarEmpresa && { id_empresa: verEditarEmpresa?.id }),
            clave: formik.values.clave,
            razon_social: formik.values.razon_social,
            nombre: formik.values.nombre,
            rfc: formik.values.rfc,
            direccion: formik.values.direccion,
            contacto: formik.values.contacto,
            correo: formik.values.correo,
            telefono: formik.values.telefono,
            logo: formik.values.logo,
            id_usuario: idUsuario,
          };
          createEditEmpresa(datos);
        }}
        colorAction={verEditarEmpresa ? "#D4AF37" : "#50C878"}
        hoverColorAction={verEditarEmpresa ? "#a98c2c" : "#40a060"}
        textColorAction={verEditarEmpresa ? "#3D3E3D" : "#000000"}
      >
        <FormikProvider value={formik!}>
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12} md={12} mt={2}>
              <Typography
                variant="h5"
                color="primary"
                gutterBottom
                sx={{ color: "#004c93", textAlign: "center" }}
              >
                {verEditarEmpresa ? "Editar Empresa" : "Registrar Empresa"}
              </Typography>
            </Grid>
            <br />
            <Grid item xs={12} sm={6}>
              <TextField
                id="clave"
                fullWidth
                label={`${intl.formatMessage({ id: "input_clave" })}`}
                variant="outlined"
                name="clave"
                value={formik.values.clave || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("clave", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.clave && Boolean(formik.errors.clave)}
                helperText={formik.touched.clave && formik.errors.clave}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("clave"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("clave"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("clave"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("clave"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="razon_social"
                fullWidth
                label={`${intl.formatMessage({ id: "input_razon_social" })}`}
                variant="outlined"
                name="razon_social"
                value={formik.values.razon_social || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("razon_social", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.razon_social && Boolean(formik.errors.razon_social)}
                helperText={formik.touched.razon_social && formik.errors.razon_social}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("razon_social"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("razon_social"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("razon_social"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("razon_social"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="nombre"
                fullWidth
                label={`${intl.formatMessage({ id: "input_nombre" })}`}
                variant="outlined"
                name="nombre"
                value={formik.values.nombre || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("nombre", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.nombre && Boolean(formik.errors.nombre)}
                helperText={formik.touched.nombre && formik.errors.nombre}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("nombre"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("nombre"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("nombre"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("nombre"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="direccion"
                fullWidth
                label={`${intl.formatMessage({ id: "input_direccion" })}`}
                variant="outlined"
                name="direccion"
                value={formik.values.direccion || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("direccion", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.direccion && Boolean(formik.errors.direccion)}
                helperText={formik.touched.direccion && formik.errors.direccion}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("direccion"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("direccion"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("direccion"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("direccion"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="contacto"
                fullWidth
                label={`${intl.formatMessage({ id: "input_contacto" })}`}
                variant="outlined"
                name="contacto"
                value={formik.values.contacto || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("contacto", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.contacto && Boolean(formik.errors.contacto)}
                helperText={formik.touched.contacto && formik.errors.contacto}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("contacto"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("contacto"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("contacto"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("contacto"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="correo"
                fullWidth
                label={`${intl.formatMessage({ id: "input_correo" })}`}
                variant="outlined"
                name="correo"
                value={formik.values.correo || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("correo", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.correo && Boolean(formik.errors.correo)}
                helperText={formik.touched.correo && formik.errors.correo}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("correo"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("correo"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("correo"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("correo"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4} sx={{ position: "relative" }}>
              <TextField
                id="telefono"
                fullWidth
                label={`${intl.formatMessage({ id: "input_telefono" })}`}
                variant="outlined"
                name="telefono"
                type="number"
                value={formik.values.telefono || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("telefono", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.telefono && Boolean(formik.errors.telefono)}
                helperText={formik.touched.telefono && formik.errors.telefono}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("telefono"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("telefono"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("telefono"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("telefono"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4} sx={{ position: "relative" }}>
              <TextField
                id="rfc"
                fullWidth
                label={`${intl.formatMessage({ id: "input_rfc" })}`}
                variant="outlined"
                name="rfc"
                value={formik.values.rfc || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("rfc", value);
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.rfc && Boolean(formik.errors.rfc)}
                helperText={formik.touched.rfc && formik.errors.rfc}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("rfc"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("rfc"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("rfc"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("rfc"),
                  },
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
            >
              <MuiFileInput
                value={formik.values.logo}
                onChange={handleChangeLogo}
                inputProps={{ accept: ".png, .jpeg, .jpg" }}
                error={formik.touched.logo && Boolean(formik.errors.logo)}
                helperText={formik.touched.logo && (formik.errors.logo as string)}
                placeholder={`${intl.formatMessage({ id: "subir_logo_empresa_placeholder" })}`}
              />
            </Grid>
          </Grid>
        </FormikProvider>
      </ModalComponent>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={procesando}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ModalComponent handleClose={handleisAlertClose} isOpen={isAlertOpen} key={"alerta"}>
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <br />
            <br />
            <p>{mensajeAlert}</p>
          </Grid>
        </Grid>
      </ModalComponent>
    </DashboardLayout>
  );
}

export default Empresas;
